import API from '../../../../../services/api';

export const PART_NOT_FOUND_API = {
    get: async (page, perPage) => {
        return API.get(`/pieza-no-encontrada?page=${page}&per_page=${perPage}`).then(res => res.data);
    },
    create: async (data) => {
        return API.post('/pieza-no-encontrada/create', data).then(res => res.data);
    },
}

